import React from "react";
import style from "../styles/skills.module.css";
import { motion } from "framer-motion";
import { TechIcon } from "./techIcons";

// One skill tile. Resolves its glyph from the techIcons registry by `name`.
const Skill = ({ name, delay = 0 }) => (
  <motion.div
    className={`skills-card ${style.card}`}
    initial={{ opacity: 0, y: 18 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.3 }}
    transition={{ duration: 0.4, delay }}
    whileHover={{ y: -6 }}
  >
    <span className={style.iconWrap}>
      <TechIcon name={name} className={`skills-card-img ${style.img}`} />
    </span>
    <h4 className={`skills-card-name ${style.name}`}>{name}</h4>
  </motion.div>
);

export default Skill;
